import _objectSpread from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.constructor.js";
/**
 * 下拉组件，继承Base
 * @module $ui/components/my-select
*/
import ElSelectTree from 'el-select-tree';
import Base from '../Base';

/**
 * 插槽
 * @member slots
 * @property {string} [option] 作用域插槽，参数: item 数据项，index 索引
 */
export default {
  name: 'MySelectTree',
  mixins: [Base],
  components: {
    ElSelectTree: ElSelectTree
  },
  /**
   * 通用参数之外的扩展参数
   * @member props
   * @property {Array} [group] 分组，数据项字段包括 id, label, disabled, options 中的 parentId 字段与分组id相等即标识选项在该分组下
   */
  props: {
    value: [String, Number, Boolean, Array]
  },
  computed: {
    inputSize: function inputSize() {
      if (this.size) return this.size;
      if (this.myForm) {
        return this.myForm.$attrs.size || '';
      }
      return '';
    }
  },
  data: function data() {
    return {
      treeProps: {
        value: 'id',
        children: 'children',
        label: 'name'
      }
    };
  },
  methods: {
    getDefaultValue: function getDefaultValue() {
      return this.$attrs.multiple ? [] : '';
    }
  },
  render: function render() {
    var _this = this;
    var h = arguments[0];
    var vnode = h(ElSelectTree, {
      "ref": 'comp',
      "class": 'my-select-tree',
      "props": _objectSpread({}, this.innerProps),
      "attrs": {
        "data": this.options
      },
      "model": {
        value: _this.fieldValue,
        callback: function callback($$v) {
          _this.fieldValue = $$v;
        }
      }
    });
    return this.renderComponent(vnode);
  }
};